import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const WorkTimeControlIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  isFilled,
  fillOpacity,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2c2.6522 0 5.1957 1.05357 7.0711 2.92893C20.9464 6.8043 22 9.34784 22 12c0 2.6522-1.0536 5.1957-2.9289 7.0711C17.1957 20.9464 14.6522 22 12 22c-2.65216 0-5.1957-1.0536-7.07107-2.9289C3.05357 17.1957 2 14.6522 2 12c0-2.65216 1.05357-5.1957 2.92893-7.07107ZM12 7.81395c.3853 0 .6977.31236.6977.69768v3.19947l4.1557 4.1566c.2724.2724.2724.7142-.0001.9866-.2725.2724-.7143.2724-.9867-.0001l-4.36-4.3609c-.1308-.1309-.2043-.3083-.2043-.4933V8.51163c0-.38532.3124-.69768.6977-.69768Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      d="M20.5938 11.573c-.1056-2.1266-.9964-4.14491-2.5091-5.65767C16.471 4.30165 14.2821 3.39535 12 3.39535c-2.28209 0-4.47098.9063-6.08467 2.51998C4.30165 7.52902 3.39535 9.71791 3.39535 12c0 2.2821.9063 4.471 2.51998 6.0847 1.61369 1.6137 3.80258 2.52 6.08467 2.52 2.2821 0 4.471-.9063 6.0847-2.52 1.6137-1.6137 2.52-3.8026 2.52-6.0847l-.0109-.427Zm-9.2915-3.06137c0-.38532.3124-.69768.6977-.69768s.6977.31236.6977.69768v3.19947l4.156 4.157c.2721.2725.2715.7143-.0009.9866-.2725.272-.7142.2723-.9865 0l-4.3596-4.3614c-.1308-.1309-.2044-.3083-.2044-.4933V8.51163Zm10.685 3.98437c-.1227 2.4716-1.158 4.8171-2.9161 6.5752C17.1959 20.9466 14.6522 22 12 22c-2.65216 0-5.19586-1.0534-7.07122-2.9288C3.05342 17.1959 2 14.6522 2 12c0-2.65216 1.05342-5.19586 2.92878-7.07122C6.80414 3.05342 9.34784 2 12 2c2.6522 0 5.1959 1.05342 7.0712 2.92878C20.9466 6.80414 22 9.34784 22 12l-.0127.496Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="Work time control" viewBox={viewBox} size={size}>
      {path}
    </SvgWrapper>
  )
}

export default WorkTimeControlIcon
